import 'polyfills';

import ReactOnRails from 'react-on-rails';

import FeatureFlagAlert from '../components/FeatureFlag/FeatureFlagAlert';
import Switcher from '../components/location/Switcher';
import CrossingLocale from '../components/location/CrossingLocale';
import View from '../components/Builder/View';
import Text from '../components/OC/oc-text';
import Footer from '../components/OC/footer';
import RichText from '../components/OC/oc-rich-text';

import warrantyStandardStore from '../components/Warranty/WarrantyStandardForm/redux/store';
import WarrantyStandardForm from '../components/Warranty/WarrantyStandardForm/warranty-standard-form.jsx';

ReactOnRails.registerStore({
  warrantyStandardStore,
});

ReactOnRails.register({
  WarrantyStandardForm: WarrantyStandardForm,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': CrossingLocale,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Builder::View': View,
  'OC::Text': Text,
  'OC::Footer': Footer,
  'OC::Richtext': RichText,
});
